/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
* Makes a range of standard fields...
*/

import { AppFormControl } from "@src/app/shared/form/app-form-control";
import { FormButtonComponent } from "@src/app/shared/form/form-button/form-button.component";
import { FormDateTimeComponent } from "@src/app/shared/form/form-date-time/form-date-time.component";
import { FormNumberComponent } from "@src/app/shared/form/form-number/form-number.component";
import { FormTextAreaComponent } from "@src/app/shared/form/form-text-area/form-text-area.component";
import { FormTextComponent } from "@src/app/shared/form/form-text/form-text.component";
import { ButtonField, BtnOpts } from "@src/app/shared/field/ButtonField";
import { Field } from "@src/app/shared/field/Field";

export class FieldMaker {
    public static notes(options: Partial<Field> = {}) {
        const field: Field = new Field({
            cellOpts: { heading: 'Notes' }, value: 'notes', type: 'longText',
            maxLength: 150, autoComplete: 'off'
        }, options);
        field.formControlFactory = FormTextAreaComponent.createComponent;
        return field;
    }

    public static deleteGridRow(btnOpts: BtnOpts = {}, options: Partial<Field> = {}) {

        const field = new ButtonField({
            name: 'delete', type: 'icon', sendServer: false, label: '',
            cellOpts: { heading: '', width: '1%' },
            calculateValue: (o) => { if (o && o.deleted) { return 'plumbing'; } else { return 'delete'; } },
            toolTip: 'Click to delete or restore this item',
        }, options as ButtonField);

        field.btnOpts.clickMethod = (ctl: AppFormControl) => {
            if (ctl.isGridCell) {
                ctl.getRow().delete();
                if (field.valueChanges) {
                    field.valueChanges(null, field);
                }
            } else {
                console.error('Delete Grid Button appears to be attached sometwhere other than on a grid', ctl);
            }
        }
        field.btnOpts.color = 'accent';

        field.btnOpts = { ...field.btnOpts, ...btnOpts };


        return FormButtonComponent.make('delete', '', field);
    }

    public static id(options: Partial<Field> = {}) {
        const field: Field = FormNumberComponent.make("Id", "id", {}, { readonly: true, visible: Field.noShow });
        for (const key of Object.getOwnPropertyNames(options)) {
            field[key] = options[key];
        }
        return field;
        /*
            const field: Field = new Field( {type: 'number', cellOpts: {heading: 'Id'}, value: 'id', disable: true,
                numberOpts: { format: 'currency', width: 9, formatParms: '1.2-2' } ,
                visible: { phone: false, computer: false, form: false }}, options );
            field.formControlFactory = FormNumberComponent.createComponent;
            return field;
            */
    }
    public static spacer() {
        const field = FormTextComponent.make(' ', 'spacer', { cellOpts: { width: '50%', minWidth: '0%' }, readonly: true, visible: Field.noPhone })
        return field;
    }

    public static idHolder(value: string, options: Partial<Field> = {}) {
        const field: Field = FormNumberComponent.make(value, value, {}, { readonly: true, visible: Field.noShow });
        for (const key of Object.getOwnPropertyNames(options)) {
            field[key] = options[key];
        }
        return field;
    }
    public static rev(options: Partial<Field> = {}) {
        /*
      const field: Field = new Field({ type: 'number',
        cellOpts: {heading: 'Rev'}, value: 'revision',
        visible: { phone: false, computer: false, form: false }}, options
      );
      field.formControlFactory = FormNumberComponent.createComponent;
      return field;*/
        const field: Field = FormNumberComponent.make("Versions", "revision", {}, { readonly: true, visible: Field.noShow });
        for (const key of Object.getOwnPropertyNames(options)) {
            field[key] = options[key];
        }
        return field;
    }
    public static nameControl(options: Partial<Field> = {}) {
        const field: Field = new Field({ cellOpts: { heading: 'Name' }, value: 'name' }, options);
        field.formControlFactory = FormTextComponent.createComponent;
        return field;
    }
    public static createdAt() {
        return FormDateTimeComponent.make('Created', 'createdAt').override({readonly: true});
    }
    public static updatedAt() {
        return FormDateTimeComponent.make('Last Updated', 'updatedAt').override({readonly: true});
    }
}
